function Back() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" className="w-2 "
            viewBox="0 0 511.999 511.999" >
            <g>
                <path className="text-slate-500" d="M79.457,256.005L295.729,39.729c9.087-9.089,9.087-23.824-0.002-32.912
                    c-9.087-9.089-23.824-9.089-32.912,0.002L30.088,239.551c-4.364,4.363-6.816,10.282-6.816,16.454
                    c0,6.173,2.453,12.093,6.817,16.457l232.727,232.721c4.543,4.544,10.499,6.816,16.455,6.816s11.913-2.271,16.457-6.817
                    c9.087-9.089,9.087-23.824-0.002-32.912L79.457,256.005z"/>
                <path className="text-slate-500 " d="M265.639,256.005L481.911,39.729c9.089-9.089,9.089-23.824,0-32.912
                    c-9.087-9.089-23.824-9.089-32.912,0.002L216.271,239.551c-4.364,4.364-6.816,10.283-6.816,16.455
                    c0,6.173,2.453,12.093,6.817,16.457L449,505.185c4.541,4.543,10.498,6.814,16.454,6.814c5.956,0,11.913-2.271,16.457-6.817
                    c9.089-9.089,9.089-23.824,0-32.912L265.639,256.005z"/>
            </g>
        </svg>
    )
}

export default Back